import { siteConfig } from '../config/site'

/**
 * Subscribes the email to Mailchimp using the JSONP `post-json` endpoint,
 * which avoids CORS without needing a server.
 *
 * Only the email address is collected. PRIMARY and SECONDARY are the user's
 * two highest archetypes, written to custom audience fields of the same name.
 * The email is never rendered on screen, in the card, or in the URL.
 *
 * Resolves either way: a subscribe failure must never block someone's results.
 */
export function subscribeToMailchimp(params: {
  email: string
  primary: string
  secondary: string
}): Promise<void> {
  const endpoint = siteConfig.mailchimpEndpoint

  return new Promise((resolve) => {
    if (!endpoint || typeof window === 'undefined') {
      resolve()
      return
    }

    const callbackName = `mcCallback_${Date.now()}`
    const query = new URLSearchParams({
      EMAIL: params.email,
      PRIMARY: params.primary,
      SECONDARY: params.secondary,
    })

    const script = document.createElement('script')
    const cleanEndpoint = endpoint.replace(/&amp;/g, '&')
    script.src = `${cleanEndpoint}&${query.toString()}&c=${callbackName}`

    const cleanup = () => {
      delete (window as unknown as Record<string, unknown>)[callbackName]
      script.remove()
      resolve()
    }

    ;(window as unknown as Record<string, unknown>)[callbackName] = cleanup
    script.onerror = cleanup
    window.setTimeout(cleanup, 6000)

    document.body.appendChild(script)
  })
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
}
